import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

import dotenv from "dotenv";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

dotenv.config();

const firebaseConfig = {

  apiKey: "AIzaSyAr6qNMu0AQsQHUdiQG7kqKDsgsnkkG4nY",
  authDomain: "vbts-grade-vn.firebaseapp.com",
  projectId: "vbts-grade-vn",
  storageBucket: "vbts-grade-vn.appspot.com",
  messagingSenderId: "375941751401",
  appId: "1:375941751401:web:6e83b6aa92def6bf2eb8f8",
  measurementId: "G-WHF9JZB6K8"

};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider(); //for google signin
export const storage = getStorage(app);
export const database = getDatabase(app);

export const DATABASE_REFERENCE_1 = "/vbts-vn/grade-post/student";
export const DATABASE_REFERENCE_2 = "/vbts-vn/grade-post/grade-entry";